import type { IconNode } from '../types';

/**
 * @name credit-card-check
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIuNSAxOUg0YTIgMiAwIDAxLTItMlY3YTIgMiAwIDAxMi0yaDE2YTIgMiAwIDAxMiAydjQiIC8+CiAgPHBhdGggZD0iTTIgMTBoMjAiIC8+CiAgPHBhdGggZD0iTTYgMTRoMiIgLz4KICA8cGF0aCBkPSJtMTYgMTcgMiAyIDQtNCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/credit-card-check
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const CreditCardCheck: IconNode = [
  ['path', { d: 'M12.5 19H4a2 2 0 01-2-2V7a2 2 0 012-2h16a2 2 0 012 2v4' }],
  ['path', { d: 'M2 10h20' }],
  ['path', { d: 'M6 14h2' }],
  ['path', { d: 'm16 17 2 2 4-4' }],
];

export default CreditCardCheck;
